import { Component, CircleDashed, Waves, Disc3, Wrench, Package } from 'lucide-react';

// Small line icon per category — mirrors the icons used in the category nav bar.
export const categoryIcons = {
  brackets: Component,
  bands_and_tubes: CircleDashed,
  wires_and_springs: Waves,
  elastomerics: Disc3,
  orthodontic_pliers: Wrench,
  miscellaneous: Package,
};
